import { render } from "./star_background.vue?vue&type=template&id=1c4c56b5"
import script from "./star_background.vue?vue&type=script&lang=js"
export * from "./star_background.vue?vue&type=script&lang=js"

import "./star_background.vue?vue&type=style&index=0&id=1c4c56b5&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__